import { namespace } from '#root/utils/namespace.ts';

export const SKOS = namespace('http://www.w3.org/2004/02/skos/core#', 'skos');
export const RDF = namespace(
  'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  'rdf',
);
